//选择星期几
const weekOptions=[
    {id:'1',week:'星期一'},
    {id:'2',week:'星期二'},
    {id:'3',week:'星期三'},
    {id:'4',week:'星期四'},
    {id:'5',week:'星期五'},
    {id:'6',week:'星期六'},
    {id:'7',week:'星期日'},
]
//星期全选时对应的id
const weekIds=['1','2','3','4','5','6','7']
//选择月份
const monthOptions=[
    {id:'01',month:'一月'},
    {id:'02',month:'二月'},
    {id:'03',month:'三月'},
    {id:'04',month:'四月'},
    {id:'05',month:'五月'},
    {id:'06',month:'六月'},
    {id:'07',month:'七月'},
    {id:'08',month:'八月'},
    {id:'09',month:'九月'},
    {id:'10',month:'十月'},
    {id:'11',month:'十一月'},
    {id:'12',month:'十二月'},
]
//月份全选时对应的id
const monthIds=['01','02','03','04','05','06','07','08','09','10','11','12']

//天数
function dayCounts() {
    let arr=[]

    for (let i=0;i<31;i++){
        let obj={id:null,day:null}
        let a =i+1
        obj.id=a.toString()
        obj.day=a<10?"0"+a.toString():a.toString()
        arr.push(obj)
    }
    return arr
}
const days=dayCounts()

//巡检表单默认填写
const tableDefaultData=[
    {
        checkItem:'硬件故障',
        operationPrompt:'查看服务器设备故障灯',
        conclusion:'true',
        summary:'',
    },
    {
        checkItem:'补丁(如果有装补丁，请详细登记补丁名称与对应服务器名称)',
        operationPrompt:'是否有新补丁需要测试安装',
        conclusion:'true',
        summary:'',
    },
    {
        checkItem:'防病毒',
        operationPrompt:'病毒库是否升级为最新',
        conclusion:'true',
        summary:'',
    },
    {
        checkItem:'系统事件',
        operationPrompt:'无错误事件与不明登录事件',
        conclusion:'true',
        summary:'',
    },
    {
        checkItem:'日志文件',
        operationPrompt:'设置以及运行正常',
        conclusion:'true',
        summary:'',
    },
    {
        checkItem:'磁盘卷组',
        operationPrompt:'无处于时效状态的逻辑卷',
        conclusion:'true',
        summary:'',
    },{
        checkItem:'功能',
        operationPrompt:'域用户正常登录',
        conclusion:'true',
        summary:'',
    },{
        checkItem:'文件服务器正常访问',
        operationPrompt:'',
        conclusion:'true',
        summary:'',
    },{
        checkItem:'文件功能正常',
        operationPrompt:'',
        conclusion:'true',
        summary:'',
    },{
        checkItem:'域服务',
        operationPrompt:'检查系统日志文件无错误信息',
        conclusion:'true',
        summary:'',
    },{
        checkItem:'数据备份',
        operationPrompt:'最近备份时间',
        conclusion:'true',
        summary:'',
    },
]
function change() {
    return [
        {
            checkItem:'硬件故障',
            operationPrompt:'查看服务器设备故障灯',
            conclusion:'true',
            summary:'',
        },
        {
            checkItem:'补丁(如果有装补丁，请详细登记补丁名称与对应服务器名称)',
            operationPrompt:'是否有新补丁需要测试安装',
            conclusion:'true',
            summary:'',
        },
        {
            checkItem:'防病毒',
            operationPrompt:'病毒库是否升级为最新',
            conclusion:'true',
            summary:'',
        },
        {
            checkItem:'系统事件',
            operationPrompt:'无错误事件与不明登录事件',
            conclusion:'true',
            summary:'',
        },
        {
            checkItem:'日志文件',
            operationPrompt:'设置以及运行正常',
            conclusion:'true',
            summary:'',
        },
        {
            checkItem:'磁盘卷组',
            operationPrompt:'无处于时效状态的逻辑卷',
            conclusion:'true',
            summary:'',
        },{
            checkItem:'功能',
            operationPrompt:'域用户正常登录',
            conclusion:'true',
            summary:'',
        },{
            checkItem:'文件服务器正常访问',
            operationPrompt:'',
            conclusion:'true',
            summary:'',
        },{
            checkItem:'文件功能正常',
            operationPrompt:'',
            conclusion:'true',
            summary:'',
        },{
            checkItem:'域服务',
            operationPrompt:'检查系统日志文件无错误信息',
            conclusion:'true',
            summary:'',
        },{
            checkItem:'数据备份',
            operationPrompt:'最近备份时间',
            conclusion:'true',
            summary:'',
        },
    ]
}


export {
    weekOptions,weekIds,monthOptions,monthIds,days,tableDefaultData,change
}
